const DEVICE_CREATED = 'DEVICE_CREATED'
const SHOW_QR_CODE = 'SHOW_QR_CODE'
const SIGN_OUT = 'SIGN_OUT'
const MOBILE_ACCESS_TOKEN_UNAUTHORIZED = 'MOBILE_ACCESS_TOKEN_UNAUTHORIZED'

// TODO: do not send to * anybody, for security
export function usePostDeviceCreated() {
    return (deviceKey: string, customerId: string, customerName: string) => {
        window.parent.postMessage(
            {
                action: DEVICE_CREATED,
                deviceKey: deviceKey,
                customerId: customerId,
                customerName: customerName
            },
            '*'
        )
    }
}

export function usePostShowQrCode() {
    return () => {
        window.parent.postMessage(
            {
                action: SHOW_QR_CODE
            },
            '*'
        )
    }
}

export function usePostSignOut() {
    return () => {
        window.parent.postMessage(
            {
                action: SIGN_OUT
            },
            '*'
        )
    }
}

export function postMobileAccessTokenUnauthorized() {
    window.parent.postMessage(
        {
            action: MOBILE_ACCESS_TOKEN_UNAUTHORIZED
        },
        '*'
    )
}
